import { environment } from '../../environments/environment';
import { WSRoute } from './types';
import { authTokenStorage } from '../utils/auth-token-storage';

function normalizeBaseURL(base?: string): string | undefined {
  const trimmed = base?.trim();
  return trimmed ? trimmed.replace(/\/+$/, '') : undefined;
}

function getBrowserWebSocketBaseURL(): string | undefined {
  if (typeof window === 'undefined' || !window.location?.host) return undefined;

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}`;
}

export function buildWebSocketURL(route: WSRoute, id?: number): string {
  const base = normalizeBaseURL(environment.webSocketBaseURL) ?? getBrowserWebSocketBaseURL();
  if (!base) {
    throw new Error('REACT_APP_WS_BASE_URL não configurada e não foi possível inferir a URL pelo host atual');
  }

  const idSegment = id !== undefined ? `/${id}` : '';
  return `${base}/ws/${route}${idSegment}/`;
}

// Carries the access token as a WebSocket subprotocol (Sec-WebSocket-Protocol
// header) instead of a `?token=` query string, so it isn't captured by proxy
// or server access logs the way the request URL is. Returned as the
// `protocols` argument for the `WebSocket` constructor.
export function buildWebSocketAuthProtocols(): string[] | undefined {
  const token = authTokenStorage.get();
  return token ? ['access_token', token] : undefined;
}
